import {
    IconTachometer,
    IconMessages,
    IconPaperPlane,
    IconUserFriends,
    IconCalendarTomorrow,
    IconFlag,
    IconRepeat,
    IconCog,
    IconFourDotsCircle,
    IconUsers,
    IconCommentLines,
    //IconMoneyBill,
    IconMegaphone
} from '@7shifts/sous-chef';
import { NavBarItems } from 'app-layout-frame/dist/layout/types';
import { __ } from 'i18n';
import { User, WhatsApp } from 'types';
import { FEATURES } from './features';
import { useFeature } from 'contexts/FeaturesContext/FeaturesContext';

export const getNavItems = (user: User, whatsApps: WhatsApp[]): NavBarItems => {
    const nonConnectedChannel = whatsApps.find(
        (item) => item.status !== 'CONNECTED'
    );
    const isAdmin = user.profile === 'admin';
    const isSupervisor = user.profile === 'supervisor';
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { hasFeature } = useFeature();
    const isCampaignsEnabled = hasFeature(FEATURES.CAMPANHAS);
    const isFollowUpEnabled = hasFeature(FEATURES.FOLLOW_UP);
    const layoutMode = JSON.parse(String(localStorage.getItem('layoutMode')));

    return [
        {
            label: __('main.dashboard'),
            isActive: true,
            isShowing: true,
            url: '/dashboard',
            icon: IconTachometer
        },
        {
            label: __('main.tickets'),
            isActive: false,
            isShowing: true,
            url: layoutMode === 'list' ? '/tickets' : '/kanban',
            icon: IconMessages
        },
        {
            label: __('main.modelMessages'),
            isActive: false,
            isShowing:
                !!whatsApps.find((channel) => channel.tokenMeta !== null) &&
                (isSupervisor || isAdmin),
            url: '/message-templates',
            icon: IconCommentLines
        },
        {
            label: __('main.campaigns'),
            isActive: false,
            isShowing: isCampaignsEnabled,
            url: '/campaigns',
            icon: IconMegaphone,
            badge: 'new'
        },
        {
            label: __('main.quickMessages'),
            isActive: false,
            isShowing: true,
            url: '/quick-messages',
            icon: IconPaperPlane
        },
        {
            label: __('main.contacts'),
            isActive: false,
            isShowing: true,
            url: '/contacts',
            icon: IconUserFriends
        },
        {
            label: __('main.schedules'),
            isActive: false,
            isShowing: true,
            url: '/schedules',
            icon: IconCalendarTomorrow
        },
        {
            label: __('main.tags'),
            isActive: false,
            isShowing: true,
            url: '/tags',
            icon: IconFlag
        },
        {
            type: 'divider'
        },
        {
            label: __('main.reports'),
            isActive: false,
            isShowing: isAdmin,
            url: '/reports',
            icon: IconTachometer
        },
        {
            label: __('main.channels'),
            isActive: false,
            isShowing: isAdmin,
            url: '/channels',
            icon: IconFourDotsCircle,
            badge:
                whatsApps.length === 0 || nonConnectedChannel
                    ? 'Missing'
                    : undefined
        },
        {
            label: __('main.queues'),
            isActive: false,
            isShowing: isAdmin,
            url: '/queues',
            icon: IconRepeat
        },
        {
            label: __('main.users'),
            isActive: false,
            isShowing: isAdmin,
            url: '/users',
            icon: IconUsers
        },
        // {
        //     label: __('main.invoices'),
        //     isActive: false,
        //     isShowing: isAdmin,
        //     url: '/invoices',
        //     icon: IconMoneyBill
        // },
        {
            label: __('main.settings'),
            isActive: false,
            isShowing: isAdmin,
            url: '/settings',
            icon: IconCog
        },
        {
            label: __('chatbotFollowupPage.navLabel'),
            isActive: false,
            isShowing: isAdmin && isFollowUpEnabled,
            url: '/chatbot-followup',
            icon: IconFlag
        }
    ];
};
